import { render, staticRenderFns } from "./EstDes3.vue?vue&type=template&id=56c676d8&scoped=true&"
import script from "./EstDes3.vue?vue&type=script&lang=js&"
export * from "./EstDes3.vue?vue&type=script&lang=js&"
import style0 from "./EstDes3.vue?vue&type=style&index=0&id=56c676d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c676d8",
  null
  
)

export default component.exports